import React from 'react';
import { Platform, View } from 'react-native';
import { Video as ExpoVideo } from 'expo-av';
import type { VideoProps } from './Video.types';

export default function Video({ source, style }: VideoProps) {
  if (Platform.OS === 'web') {
    if (typeof source !== 'string') return null;

    return (
      <div style={{ width: '100%', height: 'auto', overflow: 'hidden' }}>
        <video
          src={source}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>
    );
  }

  return (
    <View style={style}>
      <ExpoVideo
        source={typeof source === 'string' ? { uri: source } : source}
        style={{ width: '100%', height: '100%' }}
        shouldPlay
        isLooping
        isMuted
        useNativeControls={false}
      />
    </View>
  );
}
